export const getCGTCustomMMDispoOptionLabel = (
    code: string | null,
    label: string,
    fieldName: string,
    company?: string,
) =>
    company?.startsWith('cgt') && fieldName.includes('mm_dispo') && code
        ? `${code} - ${label}`
        : label;
